import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShoppingCart, Menu, X, User, LogOut, LayoutDashboard } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";

export const Navbar = () => {
  const { count } = useCart();
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  const links = [
    { to: "/", label: "Home" },
    { to: "/catalog", label: "Shop" },
    { to: "/catalog?category=Pokemon", label: "Pokémon" },
    { to: "/catalog?category=Sealed", label: "Sealed" },
    { to: "/sports-cards", label: "Sports" },
  ];

  return (
    <header className="glass sticky top-0 z-50 border-b border-white/10">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex h-[68px] items-center justify-between">
          <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
            <span className="font-display text-xl font-900 tracking-tighter text-white">LAMOTTA</span>
            <span className="h-2 w-2 rounded-full bg-secondary shadow-[0_0_12px_2px_hsl(186_100%_50%)]" />
          </Link>

          <nav className="hidden items-center gap-8 md:flex">
            {links.map((l) => (
              <Link key={l.label} to={l.to} data-testid={`nav-link-${l.label.toLowerCase()}`}
                className="text-sm text-zinc-400 transition-colors hover:text-white">
                {l.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            {user && user.role === "admin" && (
              <Link to="/admin" data-testid="nav-admin" className="hidden md:inline-flex items-center gap-2 rounded-full border border-white/10 px-4 py-2 text-sm text-zinc-300 transition-colors hover:bg-white/5 hover:text-white">
                <LayoutDashboard size={16} /> Admin
              </Link>
            )}
            {user ? (
              <button data-testid="nav-logout" onClick={() => { logout(); nav("/"); }}
                className="hidden md:inline-flex items-center gap-2 rounded-full border border-white/10 px-4 py-2 text-sm text-zinc-300 transition-colors hover:bg-white/5 hover:text-white">
                <LogOut size={16} /> {user.name?.split(" ")[0]}
              </button>
            ) : (
              <Link to="/login" data-testid="nav-login" className="hidden md:inline-flex items-center gap-2 rounded-full border border-white/10 px-4 py-2 text-sm text-zinc-300 transition-colors hover:bg-white/5 hover:text-white">
                <User size={16} /> Sign in
              </Link>
            )}
            <Link to="/cart" data-testid="nav-cart" className="relative rounded-full bg-primary p-2.5 text-white transition-transform hover:-translate-y-0.5">
              <ShoppingCart size={18} />
              {count > 0 && (
                <span data-testid="cart-count" className="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-secondary px-1 text-[11px] font-bold text-black">{count}</span>
              )}
            </Link>
            <button className="md:hidden text-white" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
              {open ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="border-t border-white/10 bg-zinc-950 px-5 py-4 md:hidden">
          {links.map((l) => (
            <Link key={l.label} to={l.to} onClick={() => setOpen(false)} className="block py-2 text-zinc-300">{l.label}</Link>
          ))}
          {user && user.role === "admin" && <Link to="/admin" onClick={() => setOpen(false)} className="block py-2 text-zinc-300">Admin</Link>}
          {user ? (
            <button onClick={() => { logout(); setOpen(false); nav("/"); }} className="block py-2 text-zinc-300">Sign out</button>
          ) : (
            <Link to="/login" onClick={() => setOpen(false)} className="block py-2 text-zinc-300">Sign in</Link>
          )}
        </div>
      )}
    </header>
  );
};
